import React from 'react'
import StyledFlexContainer from '../../../../components/containers/flex-container.component'
import { StyledContainer, StyledForm } from './trip-search-section.styles'
import { SearchForm } from '../../../../components/trip-search-bar'

export class TripSearchSection extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<StyledContainer>
				<StyledForm>
					<h1 className="white f-xx-large title-ticket-sale">
						<span>Viação Planalto Transportes - </span>
						{this.props.muvibus
							? `Compre agora a economize!`
							: `Passagens de ônibus mais baratas sem sair de casa`}
					</h1>
					<SearchForm />
				</StyledForm>
			</StyledContainer>
		)
	}
}
